var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKingpolisLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 76.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-4 {\n        fill: #f27321;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #f39200;\n      }\n\n      .cls-7 {\n        fill: #009ec2;\n      }\n\n      .cls-8 {\n        fill: #17364b;\n      }\n\n      .cls-9 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 0 0 0 1.94;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #0a364b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .66px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M15.51,73.73c0-1.53-.21-1.71-1.34-1.71s-1.34,.18-1.34,1.71,.21,1.78,1.34,1.78,1.34-.23,1.34-1.78m1.38-.02c0,2.31-.93,2.98-2.73,2.98s-2.73-.67-2.73-2.98,.93-2.88,2.73-2.88,2.73,.6,2.73,2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.26,76.58h-1.61c-.69-1.28-1.44-2.57-2.21-3.83v3.83h-1.27v-5.61h1.69c.72,1.18,1.44,2.44,2.11,3.69v-3.69h1.29v5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27,72.1h-.89v3.33h.89c1.13,0,1.43-.23,1.43-1.67s-.3-1.66-1.43-1.66m.15-1.13c1.79,0,2.66,.59,2.66,2.78s-.87,2.83-2.66,2.83h-2.34v-5.61h2.34Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "31.11 70.97 31.11 76.58 35.3 76.58 35.3 75.44 32.41 75.44 32.41 74.22 34.48 74.22 34.48 73.11 32.41 73.11 32.41 72.1 35.3 72.1 35.3 70.97 31.11 70.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.69,73.51h1.44c.28,0,.49-.2,.49-.7s-.19-.74-.47-.74h-1.46v1.44Zm3.81,3.07h-1.62c-.87-1.53-1.27-2-1.62-2h-.58v2h-1.3v-5.61h3.13c1.15,0,1.54,.72,1.54,1.64,0,.8-.34,1.51-1.4,1.56,.38,.14,.8,.64,1.84,2.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.63,72.1h-.89v3.33h.89c1.13,0,1.43-.23,1.43-1.67s-.3-1.66-1.43-1.66m.15-1.13c1.79,0,2.66,.59,2.66,2.78s-.87,2.83-2.66,2.83h-2.34v-5.61h2.34Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "48.74 70.97 48.74 76.58 52.92 76.58 52.92 75.44 50.03 75.44 50.03 74.22 52.1 74.22 52.1 73.11 50.03 73.11 50.03 72.1 52.92 72.1 52.92 70.97 48.74 70.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "54.02 70.97 54.02 76.58 58.2 76.58 58.2 75.44 55.31 75.44 55.31 74.22 57.38 74.22 57.38 73.11 55.31 73.11 55.31 72.1 58.2 72.1 58.2 70.97 54.02 70.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "59.29 70.97 59.29 76.58 63.11 76.58 63.11 75.43 60.59 75.43 60.59 70.97 59.29 70.97"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.8,70.97c.46,1.09,1.13,3,1.48,4.22,.46-1.17,1.04-3.04,1.38-4.22h1.38c-.46,1.58-1.36,4.04-2.02,5.61h-1.66c-.52-1.73-1.35-4.14-2-5.61h1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.76,72.09c-.22,.59-.47,1.34-.73,2.12h1.61c-.26-.76-.5-1.53-.67-2.12h-.21Zm1.25,3.24h-2.31c-.14,.47-.27,.89-.36,1.24h-1.38c.47-1.57,1.34-4.03,1.99-5.61h2c.53,1.75,1.37,4.14,1.97,5.61h-1.43c-.14-.33-.31-.76-.47-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.64,76.58h-1.61c-.69-1.28-1.44-2.57-2.21-3.83v3.83h-1.27v-5.61h1.69c.72,1.18,1.44,2.44,2.11,3.69v-3.69h1.29v5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.49,72.09c-.22,.59-.47,1.34-.73,2.12h1.61c-.26-.76-.5-1.53-.67-2.12h-.21Zm1.25,3.24h-2.31c-.14,.47-.27,.89-.36,1.24h-1.38c.47-1.57,1.34-4.03,1.99-5.61h2c.53,1.75,1.37,4.14,1.97,5.61h-1.43c-.14-.33-.31-.76-.47-1.24"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "92.28 70.97 92.28 76.58 96.1 76.58 96.1 75.43 93.58 75.43 93.58 70.97 92.28 70.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99.64,73.76c.34,0,.56-.23,.56-.82s-.19-.86-.55-.86h-1.4v1.68h1.38Zm-2.68,2.82v-5.61h3.13c1.15,0,1.54,.82,1.54,1.97,0,1.01-.48,1.89-1.53,1.89h-1.84v1.75h-1.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 102.71,
    y: 70.97,
    width: 1.3,
    height: 5.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.65,76.58h-1.61c-.69-1.28-1.44-2.57-2.21-3.83v3.83h-1.27v-5.61h1.69c.72,1.18,1.44,2.44,2.11,3.69v-3.69h1.29v5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.19,72.09c-.22,.59-.47,1.34-.73,2.12h1.61c-.26-.76-.5-1.53-.67-2.12h-.21Zm1.25,3.24h-2.31c-.14,.47-.27,.89-.36,1.24h-1.38c.47-1.57,1.34-4.03,1.99-5.61h2c.53,1.75,1.37,4.14,1.97,5.61h-1.43c-.14-.33-.31-.76-.47-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.48,74.27h-1.11v-1.11h2.44v3.26c-.47,.14-1.41,.27-2.13,.27-1.8,0-2.66-.68-2.66-2.97s1.01-2.89,2.88-2.89c.52,0,1.33,.08,1.75,.2l-.23,1.14c-.28-.1-1.05-.16-1.39-.16-1.21,0-1.62,.17-1.62,1.72s.42,1.75,1.54,1.75c.18,0,.39-.02,.53-.04v-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M127.55,73.51h1.44c.28,0,.49-.2,.49-.7s-.19-.74-.47-.74h-1.46v1.44Zm3.81,3.07h-1.62c-.87-1.53-1.27-2-1.62-2h-.58v2h-1.3v-5.61h3.13c1.15,0,1.54,.72,1.54,1.64,0,.8-.34,1.51-1.4,1.56,.38,.14,.8,.64,1.84,2.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.11,73.73c0-1.53-.21-1.71-1.34-1.71s-1.34,.18-1.34,1.71,.21,1.78,1.34,1.78,1.34-.23,1.34-1.78m1.38-.02c0,2.31-.93,2.98-2.73,2.98s-2.73-.67-2.73-2.98,.93-2.88,2.73-2.88,2.73,.6,2.73,2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.51,70.97v4.04c0,1.35-.94,1.68-2.41,1.68s-2.41-.33-2.41-1.68v-4.04h1.31v3.39c0,.75,.02,1.13,1.09,1.13s1.1-.39,1.1-1.13v-3.39h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M147.69,73.76c.34,0,.56-.23,.56-.82s-.19-.86-.55-.86h-1.4v1.68h1.38Zm-2.68,2.82v-5.61h3.13c1.15,0,1.54,.82,1.54,1.97,0,1.01-.48,1.89-1.53,1.89h-1.84v1.75h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M5.06,65.74c.41,4.38,.74,4.72,5.03,5.16-4.29,.41-4.63,.76-5.06,5.13-.4-4.38-.74-4.72-5.03-5.16,4.29-.42,4.63-.76,5.06-5.13"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 60.64,
    width: 150,
    height: 6.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.66,
    y1: 66.97,
    x2: 11.66,
    y2: 66.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 13.61,
    y1: 66.97,
    x2: 148.62,
    y2: 66.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 149.59,
    y1: 66.97,
    x2: 149.59,
    y2: 66.97
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.39,51.85c-3.99-5.8-6.72-9.38-7.69-9.8v9.65h-4.3V23.34h4.3v18.71c.97-.8,3.37-3.65,6.84-8.33h5.1c-3.4,4.58-5.83,7.29-6.77,8.02,.9,.56,3.82,4.24,7.57,10.11h-5.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.51,
    y: 33.72,
    width: 4.3,
    height: 18.13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.18,51.85h-4.3v-17.12c2.14-.83,5.55-1.53,8.36-1.53,4.96,0,7.19,1.98,7.19,8.33v10.32s-4.3,0-4.3,0v-9.87c0-3.92-.74-4.9-3.79-4.9-1.11,0-2.12,.14-3.16,.42v14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.64,37.33c-1.01-.38-2.33-.59-3.4-.59-3.06,0-4.06,.8-4.06,5.83,0,4.41,.94,5.52,3.96,5.52,1.91,0,3.51-.59,3.51-1.67v-9.1Zm-4.48,14.48c-4.86,0-7.43-2.01-7.43-9.2s2.67-9.41,8.51-9.41c2.53,0,5.8,.52,7.71,1.32v15.52c0,6.91-3.85,10.6-9.44,10.6-2.01,0-4.69-.45-6.21-1.04l.87-3.47c1.63,.52,3.64,.87,5.31,.87,3.26,0,5.17-3.07,5.17-6.33-.97,.59-2.46,1.15-4.48,1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.49,5.6l-.15-.04c-1.4,0-2.55-.69-2.61-1.56-1.54,.23-2.99,.8-4.22,1.44,.96,.17,2.29,.45,3.19,.84,1.26-.48,2.66-.84,3.78-.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.3,6.92c7.66,2.72,11.68,2.72,11.68,2.72l-12.69-3.81c.44,.21,.79,.56,1.01,1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.98,26.29s2.56-.96,3.94-2.05c1.51-1.06,3.1-2.56,4.42-4.67,3.79-6.06,2.05-10.15,2.05-10.15-1.62,.42-3.58-.06-4.31-.28-.02,.01-.03,.02-.05,.04,5.01,4.33,.58,10.74-4.56,15.73-.48,.47-.97,.92-1.45,1.36,0,0-.02,.02-.03,.03h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.28,5.83c-.11-.05-.21-.1-.33-.13-.02,0-.03-.01-.05-.02-.13-.04-.27-.07-.41-.09-1.12-.17-2.52,.19-3.78,.67-1.63,.62-3.02,1.44-3.28,1.6-3.54-.8-11.61,.04-11.26,24.5,0,0,3.87-2.54,7.81-6.08,0,0,.02-.02,.03-.03,.49-.44,.97-.89,1.45-1.36,5.14-4.98,9.57-11.39,4.56-15.73,.02-.01,.03-.02,.05-.04,1.95-1.55,3.37-1.17,3.37-1.17,0-.98,2.88-1.02,2.88-1.02,0-.01-.01-.02-.02-.04-.23-.52-.58-.87-1.01-1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.05,5.68c-.05,0-.1,0-.16-.02-.08-.02-.17-.06-.26-.12-.04-.03-.09-.06-.13-.09-.04-.03-.08-.07-.12-.1-.31-.31-.43-.71-.25-.89,.17-.17,.55-.07,.86,.23,0,0,.01,.01,.02,.02,.08,.08,.15,.17,.2,.26,.1,.16,.14,.33,.13,.46,0,.07-.03,.13-.08,.17-.02,.02-.04,.03-.06,.04-.04,.02-.09,.03-.15,.04m-2.16-1.14c-.12,0-.21-.1-.21-.21s.1-.21,.21-.21,.21,.1,.21,.21-.1,.21-.21,.21m4.55-.16s.01,.04,.01,.04l-.75,.2-.08,.02c-.19-.09-.37-.16-.56-.24-.13-.05-.26-.09-.39-.13-1.33-.43-2.67-.47-3.94-.28,.06,.87,1.2,1.56,2.61,1.56l.15,.04c.14,.02,.28,.05,.41,.09,.02,0,.03,0,.05,.02,.11,.04,.22,.08,.33,.13l12.69,3.81c.13-.76-7.91-4.17-10.54-5.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M22.44,4.38c-.11-.39-1.27-3.85-6.35-4.35-5.37-.53-7.27,7.95-7.27,7.95,0,0,1.48-1.38,3.69-2.54,1.23-.64,2.68-1.21,4.22-1.44,1.27-.19,2.61-.14,3.94,.28,.13,.04,.26,.08,.39,.13,.19,.07,.37,.15,.56,.24l.08-.02,.75-.2s0-.02-.01-.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.89,4.11c-.12,0-.21,.1-.21,.21s.1,.21,.21,.21,.21-.1,.21-.21-.1-.21-.21-.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.22,4.97c-.05-.09-.12-.18-.2-.26,0,0-.01-.01-.02-.02-.31-.3-.69-.4-.86-.23-.18,.18-.06,.57,.25,.89,.04,.04,.08,.07,.12,.1,.04,.03,.09,.07,.13,.09,.09,.06,.18,.09,.26,.12,.06,.02,.11,.02,.16,.02,.05-.01,.1-.02,.15-.04,.02-.01,.05-.03,.06-.04,.04-.04,.07-.1,.08-.17,.02-.13-.03-.29-.13-.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M131.78,28.4c0,1.26-1.02,2.27-2.27,2.27s-2.27-1.02-2.27-2.27,1.02-2.27,2.27-2.27,2.27,1.02,2.27,2.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.36,28.96c0,1.48-1.2,2.69-2.69,2.69s-2.69-1.2-2.69-2.69,1.2-2.69,2.69-2.69,2.69,1.2,2.69,2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.17,42.61c0,5.81-1.5,6.74-5.08,6.74-2.14,0-4.45-.67-4.45-2.13v-10.7c1.22-.4,2.83-.62,4.45-.62,3.87,0,5.08,.93,5.08,6.71m-5.08-9.61c-2.04,0-5.18,.49-7.24,1.42l-.22,.1v26.08h3v-9.46c1.19,.74,2.69,1.11,4.45,1.11,5.99,0,8.32-2.72,8.32-9.71s-2.33-9.54-8.32-9.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.73,42.61c0,5.87-1.51,6.81-5.11,6.81s-5.08-.95-5.08-6.81,1.27-6.78,5.08-6.78,5.11,.94,5.11,6.78m-5.11-9.61c-5.99,0-8.32,2.67-8.32,9.54s2.33,9.71,8.32,9.71,8.36-2.72,8.36-9.71-2.27-9.54-8.36-9.54"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 128,
    y: 33.49,
    width: 3,
    height: 18.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.84,40.95c-3.35-.22-4.03-1.06-4.03-2.34,0-2.36,1.08-2.79,4.11-2.79,1.53,0,3.34,.35,4.86,.95l.36,.14,1.02-2.89-.38-.11c-2.1-.59-4.19-.92-5.86-.92-5.13,0-7.32,1.74-7.32,5.82s3.32,4.79,6.9,5.06c3.35,.28,3.96,1.12,3.96,2.68,0,2.47-1.21,2.89-3.93,2.89-1.78,0-4.34-.45-5.47-.97l-.38-.17-.94,2.86,.35,.12c1.76,.6,4.66,.96,6.44,.96,5.07,0,7.14-1.71,7.14-5.89,0-3.46-2.04-5.08-6.84-5.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.05,46.33V23.32s-2.98,0-2.98,0v23.13c0,3.11,1.61,5.43,5.17,5.43h.53v-2.57c-2.06,0-2.73-.99-2.73-2.98"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingpolisLogo);
export default __webpack_public_path__ + "static/media/kingpolis-logo.a45a76b8dba77e10f62dfa797bd92250.svg";
export { ForwardRef as ReactComponent };